<ul hlmSidebarMenu>
  <li hlmSidebarMenuItem>
    <button hlmSidebarMenuButton size="lg" [hlmDropdownMenuTrigger]="menu" [side]="menuSide()" align="end">
      <hlm-avatar class="rounded-lg">
        <span class="rounded-lg" hlmAvatarFallback>{{ initials() }}</span>
      </hlm-avatar>
      <div class="grid flex-1 text-left text-sm leading-tight">
        <span class="truncate font-medium">{{ name() }}</span>
        <span class="truncate text-xs">{{ user().email }}</span>
      </div>
      <ng-icon name="lucideChevronsUpDown" class="ml-auto text-base" />
    </button>
  </li>
</ul>

<ng-template #menu>
  <hlm-dropdown-menu class="min-w-56 rounded-lg">
    <hlm-dropdown-menu-label>
      <div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
        <hlm-avatar class="rounded-lg">
          <span class="rounded-lg" hlmAvatarFallback>{{ initials() }}</span>
        </hlm-avatar>
        <div class="grid flex-1 text-left text-sm leading-tight">
          <span class="truncate font-medium">{{ name() }}</span>
          <span class="truncate text-xs">{{ user().email }}</span>
        </div>
      </div>
    </hlm-dropdown-menu-label>
    <hlm-dropdown-menu-separator />
    <hlm-dropdown-menu-group>
      @for (item of items(); track item.id) {
        <button hlmDropdownMenuItem (triggered)="open(item)">
          <ng-icon [name]="item.icon" />
          {{ item.title }}
        </button>
      }
    </hlm-dropdown-menu-group>
    <hlm-dropdown-menu-separator />
    <button hlmDropdownMenuItem (triggered)="logout()">
      <ng-icon name="lucideLogOut" />
      Log out
    </button>
  </hlm-dropdown-menu>
</ng-template>
